"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  xs: '320px',
  sm: '544px',
  md: '767px',
  lg: '1025px',
  xl: '1272px'
};
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/theme/dist/cjs/layout/breakpoints.js
// module id = 1295
// module chunks = 0